import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import ModalReview from './ModalReview';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const [showReviewModal, setShowReviewModal] = useState(false);

    return (
        <footer className="bg-slate-900 text-slate-400">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div>
                        <div className="flex items-center space-x-2 mb-3">
                            <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                                <DocumentTextIcon className="w-5 h-5 text-white" />
                            </div>
                            <span className="text-lg font-semibold text-white">CV Analyse</span>
                        </div>
                        <p className="text-sm leading-relaxed max-w-md">
                            Analysez votre CV, obtenez un score et des conseils concrets pour vos candidatures.
                        </p>
                    </div>
                    <div>
                        <h3 className="text-sm font-semibold text-white mb-3">Liens</h3>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/" className="hover:text-white">Accueil</Link></li>
                            <li><Link to="/methode" className="hover:text-white">Méthode</Link></li>
                            <li><Link to="/barometre" className="hover:text-white">Baromètre</Link></li>
                            <li><Link to="/comparatifs" className="hover:text-white">Comparatifs</Link></li>
                            <li><Link to="/guides" className="hover:text-white">Guides</Link></li>
                            <li><Link to="/about" className="hover:text-white">À propos</Link></li>
                            <li><Link to="/pricing" className="hover:text-white">Tarifs</Link></li>
                            <li><Link to="/mentions-legales" className="hover:text-white">Mentions légales</Link></li>
                            <li>
                                <button
                                    type="button"
                                    onClick={() => setShowReviewModal(true)}
                                    className="hover:text-white"
                                >
                                    Laisser un avis
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
                <p className="mt-8 pt-6 border-t border-slate-800 text-sm text-slate-500">
                    © {currentYear} CV Analyse
                </p>
            </div>

            {showReviewModal && (
                <ModalReview
                    onClose={() => setShowReviewModal(false)}
                    score={null}
                />
            )}
        </footer>
    );
};

export default Footer;
